/*

conciergify.forexd.js - Multi-currency for Shopify stores.

Written by Gavin Terrill - www.shopifyconcierge.com. Copyright (c) 2010. All rights reserved.

dependencies: 
-  jquery 1.4.1
-  jquery.cookie
-  {{ 'api.jquery.js' | shopify_asset_url | script_tag }}
-  {{ '/services/javascripts/currencies.js' | script_tag }}

*/
jQuery.cookie=function(_1,_2,_3){
if(typeof _2!="undefined"){
_3=_3||{};
if(_2===null){
_2="";
_3.expires=-1;
}
var _4="";
if(_3.expires&&(typeof _3.expires=="number"||_3.expires.toUTCString)){
var _5;
if(typeof _3.expires=="number"){
_5=new Date();
_5.setTime(_5.getTime()+(_3.expires*24*60*60*1000));
}else{
_5=_3.expires;
}
_4="; expires="+_5.toUTCString();
}
var _6=_3.path?"; path="+(_3.path):"";
var _7=_3.domain?"; domain="+(_3.domain):"";
var _8=_3.secure?"; secure":"";
document.cookie=[_1,"=",encodeURIComponent(_2),_4,_6,_7,_8].join("");
}else{
var _9=null;
if(document.cookie&&document.cookie!=""){
var _a=document.cookie.split(";");
for(var i=0;i<_a.length;i++){
var _b=jQuery.trim(_a[i]);
if(_b.substring(0,_1.length+1)==(_1+"=")){
_9=decodeURIComponent(_b.substring(_1.length+1));
break;
}
}
}
return _9;
}
};

var Forexd=(function($){
var _1={};
_1.symbols=[];
_1.symbols["AUD"]="$";
_1.symbols["GBP"]="£";
_1.symbols["EUR"]="€";
_1.symbols["USD"]="$";
_1.symbols["JPY"]="¥";
_1.symbols[""]="";
_1.decimal_sep=Number("1.2").toLocaleString().substr(1,1);
_1.init=function(_2){
_1.base=_2;
};
_1.currency=function(_3){
if(typeof (_3)=="undefined"){
return $.cookie("forexd.currency")||_1.base;
}else{
$.cookie("forexd.currency",_3,{path:"/"});
}
};
_1.bind=function(id,_4){
$(id).data("forexd.prices",_1.prices(_4));
};
_1.prices=function(_5){
var _6=_1.currency();
return {price:_1.convert(_5.price,_6),price_max:_1.convert(_5.price_max,_6),price_min:_1.convert(_5.price_min,_6),price_varies:_5.price_varies,compare_at_price:_1.convert(_5.compare_at_price,_6),compare_at_price_min:_1.convert(_5.compare_at_price_min,_6),compare_at_price_max:_1.convert(_5.compare_at_price_max,_6),compare_at_price_varies:_5.compare_at_price_varies};
};
_1.convert=function(_7,_8){
return Currency.convert(_7,_1.base,_8);
};
_1.symbol=function(_9,_a){
if(typeof (_a)=="undefined"){
return _1.symbols.hasOwnProperty(_9)?_1.symbols[_9]:_9;
}else{
_1.symbols[_9]=_a;
}
};
_1.forex=function(_b){
var _c=_1.currency();
var _d=new Number((_1.convert(_b,_c)/100).toFixed(2));
var _e=_d.toLocaleString();
var _f=String(_e).split(_1.decimal_sep);
var _10=_f[0];
var _11=(_f.length>1?_f[1]:"");
_11=(_11+"00").substr(0,2);
return _1.symbol(_c)+_10+_1.decimal_sep+_11;
};
return _1;
}(jQuery));

